// extracted by mini-css-extract-plugin
export default {"addressAction":"z6-z","loading":"A6-z"};